import { jsx, jsxs } from "react/jsx-runtime";
import { Edit, TextStyleSmall, Download, Delete } from "@wix/wix-ui-icons-common/on-stage";
import { BoxSelectionBoxSize, BoxSelection, IconButton, Checkbox } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useTranslation } from "../../../contexts/translation-context.js";
import { SignatureMode } from "../signature-types.js";
import commonStyles from "../styles/common.module.scss";
import { classes } from "./signature-header-wut.st.css";
import { DATA_HOOKS } from "../../../constants/data-hooks.js";
const SignatureHeaderWUT = ({
  signatureMode,
  onModeChange,
  onClear,
  clearable,
  uploadEnabled,
  inputId,
  ariaLabelledBy,
  target
}) => {
  const { t } = useTranslation();
  const handleModeChange = ({ id }) => {
    onModeChange(id);
  };
  const modeOptions = [
    /* @__PURE__ */ jsx(
      BoxSelectionItem,
      {
        className: classes.option,
        id: SignatureMode.DRAW,
        checked: signatureMode === SignatureMode.DRAW,
        "aria-label": t("field.signature.mode.draw.label"),
        size: BoxSelectionBoxSize.small,
        children: /* @__PURE__ */ jsx(Edit, { className: classes.icon, size: "24", "aria-hidden": true })
      },
      SignatureMode.DRAW
    ),
    /* @__PURE__ */ jsx(
      BoxSelectionItem,
      {
        className: classes.option,
        id: SignatureMode.TYPE,
        checked: signatureMode === SignatureMode.TYPE,
        "aria-label": t("field.signature.mode.type.label"),
        children: /* @__PURE__ */ jsx(TextStyleSmall, { className: classes.icon, size: "24", "aria-hidden": true })
      },
      SignatureMode.TYPE
    ),
    uploadEnabled && /* @__PURE__ */ jsx(
      BoxSelectionItem,
      {
        className: classes.option,
        id: SignatureMode.UPLOAD,
        checked: signatureMode === SignatureMode.UPLOAD,
        "aria-label": t("field.signature.mode.upload.label"),
        children: /* @__PURE__ */ jsx(Download, { className: classes.icon, size: "24", "aria-hidden": true })
      },
      SignatureMode.UPLOAD
    )
  ].filter(Boolean);
  return /* @__PURE__ */ jsxs("div", { className: classNames(classes.container), children: [
    /* @__PURE__ */ jsxs("div", { className: commonStyles.visuallyHidden, "aria-live": "polite", children: [
      signatureMode === SignatureMode.DRAW && t("field.signature.mode.draw.description"),
      signatureMode === SignatureMode.TYPE && t("field.signature.mode.type.description"),
      signatureMode === SignatureMode.UPLOAD && t("field.signature.mode.upload.description")
    ] }),
    /* @__PURE__ */ jsx(
      BoxSelection,
      {
        className: classes.boxSelection,
        size: BoxSelectionBoxSize.small,
        name: "signature-mode",
        onChange: handleModeChange,
        "aria-labelledby": ariaLabelledBy,
        "aria-controls": inputId,
        "data-hook": DATA_HOOKS.SIGNATURE_FIELD_MODE_SELECT,
        children: modeOptions
      }
    ),
    clearable && /* @__PURE__ */ jsx(
      IconButton,
      {
        onClick: onClear,
        "data-hook": `clear-${target}`,
        "aria-label": t("field.signature.clear-button.label"),
        "aria-controls": inputId,
        role: "button",
        icon: /* @__PURE__ */ jsx(Delete, { className: classes.clearIcon, "aria-hidden": "true" })
      }
    )
  ] });
};
const BoxSelectionItem = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ jsx(BoxSelection.Option, { ...rest, children });
};
BoxSelectionItem.includeCheckboxInBundle = Checkbox;
export {
  BoxSelectionItem,
  SignatureHeaderWUT
};
//# sourceMappingURL=signature-header-wut.js.map
